(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'CarSelectEquipment',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		var selected = [];

		// try to prevent someone from selecting both left and right hand drive.
		$('input[type="checkbox"]', $form).on('click', function fixDumbness() {

			var $self = $(this);

			if ($self.is(':checked')) {
				selected.push($self.val());
			} else {
				selected.splice(selected.indexOf($self.val()), 1);
			}

			if (selected.indexOf('HCL') >= 0 && selected.indexOf('HCR') >= 0) {
				Adzuki.StatusMessage('info', 'You cannot select both Left and Right hand controls.', 'Info');
				$self.prop('checked', false);
				selected.splice(selected.indexOf($self.val()), 1);
			}
		});
	};
}(jQuery, window.Adzuki || {}));
